import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useSettings } from '@/context/SettingsContext';
import { Baby, Clock, Waves, Palette } from 'lucide-react';

const KidsPage = () => {
  const { t } = useLanguage();
  const { settings } = useSettings();

  const features = [
    { icon: Baby, label: t('kids.ageGroup'), value: t('kids.ageGroupValue') },
    { icon: Clock, label: t('kids.hours'), value: t('kids.hoursValue') },
    { icon: Waves, label: t('kids.pool'), value: t('kids.poolValue') },
    { icon: Palette, label: t('kids.activities'), value: t('kids.activitiesValue') },
  ];

  return (
    <div data-testid="kids-page">
      {/* Hero */}
      <section
        className="relative h-[60vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('/images/kids/kids_club_1.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-holiday-purple/60" />
        <div className="relative z-10 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4">{t('kids.title')}</h1>
          <p className="text-xl text-white/80">{t('kids.subtitle')}</p>
        </div>
      </section>

      {/* Features */}
      <section className="section-padding bg-white" data-testid="kids-features">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-gray-50 p-8 rounded-lg text-center"
                data-testid={`kids-feature-${index}`}
              >
                <div className="w-16 h-16 bg-holiday-purple/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <feature.icon className="w-8 h-8 text-holiday-purple" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.label}</h3>
                <p className="text-gray-600">{feature.value}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="section-padding bg-gray-50" data-testid="kids-gallery">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <img
              src="/images/kids/kids_club_1.jpg"
              alt="Kids Club"
              className="w-full aspect-[4/3] object-cover rounded-lg shadow-lg"
            />
            <img
              src="/images/kids/kids_club_2.jpg"
              alt="Kids Activities"
              className="w-full aspect-[4/3] object-cover rounded-lg shadow-lg"
            />
            <img
              src="/images/kids/kids_club_3.jpg"
              alt="Kids Pool"
              className="w-full aspect-[4/3] object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-holiday-green text-white text-center">
        <div className="container-custom">
          <h2 className="text-4xl font-heading font-bold mb-4">
            {t('kids.subtitle')}
          </h2>
          <p className="text-white/90 mb-8">{t('hero.concept')}</p>
          <a
            href={settings.reservation_url || "https://www.ihg.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-holiday-green px-8 py-4 rounded-sm font-medium hover:bg-gray-100 transition-colors inline-block"
            data-testid="kids-cta"
          >
            {t('nav.bookNow')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default KidsPage;
